import { Popup, Icon } from 'semantic-ui-react'
import React from 'react'

const PopUpIcon = ({
  icon,
  popupText,
  className,
  color,
  basic,
  pinned,
  hoverable,
  position,
}) => {
  return (
    <Popup
      trigger={<Icon className={className} name={icon} color={color || 'blue'} />}
      hideOnScroll
      basic={basic}
      on='hover'
      position={position}
      pinned={pinned}
      hoverable={hoverable}
      content={popupText}
    />
  )
}

export default PopUpIcon
